import { render, staticRenderFns } from "./buyer-setting-payment-password.vue?vue&type=template&id=3d9cffe6&scoped=true&"
import script from "./buyer-setting-payment-password.vue?vue&type=script&lang=js&"
export * from "./buyer-setting-payment-password.vue?vue&type=script&lang=js&"
import style0 from "./buyer-setting-payment-password.vue?vue&type=style&index=0&id=3d9cffe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9cffe6",
  null
  
)

export default component.exports